import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { createZitadelAuth } from '@zitadel/react';

function Login() {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;

    const zitadel = createZitadelAuth({
      authority: process.env.REACT_APP_ZITADEL_AUTHORITY,
      client_id: process.env.REACT_APP_ZITADEL_CLIENT_ID,
      redirect_uri: window.location.origin + '/login/callback',
      response_type: 'code',
      scope: 'openid profile email',
    });

    zitadel.userManager.signinRedirectCallback()
      .then(() => {
        navigate('/');
      })
      .catch((err) => {
        console.error('Login callback error:', err);
      });
  }, [navigate]);

  const handleLogin = async () => {
    await login();
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - 64px)',
      padding: '2rem',
      background: '#f8f9fa'
    }}>
      <div style={{
        maxWidth: 400,
        width: '100%',
        padding: '2rem',
        background: 'white',
        borderRadius: 8,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <p style={{ marginBottom: '2rem', textAlign: 'center', color: '#666' }}>
          Please sign in to access the outreach portal and manage your email campaigns.
        </p>
        <button
          onClick={handleLogin}
          style={{
            width: '100%',
            padding: '0.75rem',
            background: '#4494f4',
            color: 'white',
            border: 'none',
            borderRadius: 4,
            fontSize: 16,
            fontWeight: 600,
            cursor: 'pointer'
          }}
        >
          Sign In with Zitadel
        </button>
      </div>
    </div>
  );
}

export default Login; 